export default __webpack_public_path__ + "static/media/reset-password.7ee7e974.png";